import { useEffect } from 'react'
import { useSetState } from 'ahooks'
import {
  getGoodsSaleCategoryDescList,
  goodsSaleCategoryDescDelete,
  goodsSaleCategoryDescSave,
  goodsSaleCategoryDescUpdateById,
} from '@/services/goods.ts'
import { SDrawerOrModal, SEditor, SMessage } from 'shj-components'
import { Button, message, Tabs, Tooltip } from 'antd'
import { EditOutlined } from '@ant-design/icons'
import DrawerToTab from '@/components/DrawerToTab'
import PDFPreview from '@/components/PDFPreview'
import _ from 'lodash'

export const DescModal = props => {
  const {
    record: { id: busId, busType = 'SALE_CAT_INTRODUCE' },
    descEditModalOpen,
  } = props

  const [state, setState] = useSetState({
    descType: [],
    addModal: {
      open: false,
      type: '',
      record: {},
    },
  })
  useEffect(() => {
    if (busId) getInfo()
    return () => {
      setState({ descType: [] })
    }
  }, [busId])

  const getInfo = () => {
    getGoodsSaleCategoryDescList({ busId, searchFlag: true }).then((res: any) => {
      const data = res.map(item => ({
        ...item,
        label: (
          <div>
            <span>{item.name}</span>
            <Tooltip title="编辑">
              <EditOutlined
                style={{ marginLeft: '10px' }}
                onClick={() => clickToDetail(item.subBusType, item)}
              />
            </Tooltip>
          </div>
        ),
        children: getDetailType(item.subBusType, item),
        key: item.id,
      }))
      setState({ descType: data })
    })
  }
  const openNewWindow = (url: string) => {
    if (url.indexOf('http://') !== -1 || url.indexOf('https://') !== -1) {
      window.open(url)
    } else {
      window.open('http://' + url)
    }
  }
  const getDetailType = (type: string, obj) => {
    console.log(obj.urlSite)
    const { urlSite, contentInfo } = obj
    const typeObj = {
      TYPE_TXT: <SEditor readOnly init={{toolbar: false, menubar: false, plugins:[]}} value={contentInfo} />,
      TYPE_PDF: <PDFPreview url={urlSite} key={_.uniqueId()} />,
      TYPE_VIDEO: <video style={{width: '100%'}} src={urlSite} controls={true} />,
      TYPE_DESIGN: (
        <Button
          type="link"
          onClick={() => {
            openNewWindow(urlSite)
          }}
        >
          {urlSite}
        </Button>
      ),
    }
    return typeObj[type]
  }

  const clickToDetail = (type = '', record = {}) => {
    if (!type) {
      // 新增
      if (state.descType.length < 5) {
        setState({ addModal: { open: true, type, record } })
      } else {
        message.error('最多添加5个')
      }
    } else {
      setState({ addModal: { open: true, type, record } })
    }
  }

  const onCloseDescModal = () => {
    setState({ addModal: { open: false, type: '', record: {} } })
  }

  const onSaveDesc = values => {
    const apiUrl = values.id ? goodsSaleCategoryDescUpdateById : goodsSaleCategoryDescSave
    return apiUrl({ ...values, busId, busType }).then(res => {
      message.success(res.message || '操作成功')
      onCloseDescModal()
      getInfo()
      props.fn?.()
    })
  }

  const onDel = (id: string) => {
    SMessage.confirm({
      onOk: () => {
       return goodsSaleCategoryDescDelete(id).then((res: any) => {
          message.success(res.message || '操作成功')
          getInfo()
        })
      },
    })
  }

  const onEditTab = (targetKey, action: 'add' | 'remove') => {
    if (action === 'remove') {
      onDel(targetKey)
    }
  }

  return (
    <SDrawerOrModal
      width={800}
      antdProps={{ footer: null }}
      open={descEditModalOpen}
      title={'类目介绍'}
      onCancel={props.onClose}
    >
      <div>
        <Button type="primary" onClick={() => clickToDetail()}>
          {' '}
          添加{' '}
        </Button>
      </div>
      <Tabs
        style={{ marginTop: 10 }}
        items={state.descType}
        type="editable-card"
        onEdit={onEditTab}
        hideAdd
      />
      <DrawerToTab
        filedShowName="介绍类型"
        record={state.addModal.record}
        open={state.addModal.open}
        onCancel={onCloseDescModal}
        title={`${state.addModal.record.id ? '编辑' : '新增'}类目介绍`}
        onConfirm={onSaveDesc}
      ></DrawerToTab>
    </SDrawerOrModal>
  )
}
